import React, { useEffect, useRef, useState } from "react";
import "./BottomBar.css";
import ChatInputBar from "../../../Shared/Components/ChatInputBar/ChatInputBar";
import ChatInputButton from "../../../Shared/Components/ChatInputButton/ChatInputButton";
import DefaultChips from "../../../Shared/Components/DefaultChips/DefaultChips";
import { getUserCadre, getUserKb, saveSelectedDocument } from "../../../Actions/Utils";
import { CTDCHODefaultChipsList, DEMOASHADefaultChipsList, GAVIASHADefaultChipsList, WCDAWWDefaultChipsList, BSHSFPCDefaultChipsList, POCANMDefaultChipsList } from "../../../NewConstants/OptionConstants";

const BottomBar = ({
  selectedLanguage,
  input,
  setInput = () => {},
  setAudioArr = () => {},
  audioArr,
  send = () => {},
  textSize,
  isLoading,
  audioRef,
  selectedDocument,
  optionClicked,
  chipsClicked,
  stopPlayingAudio = () => {},
  setSpeakerEnabled = () => {},
  setSelectedDocument = () => {},
  setToastErrorMessage = () => {},
  setShowToastMessage = () => {},
  setToastMessageSeverity = () => {},
  setOptionClicked = () => {},
  setChipsClicked = () => {},
  optionSelected,
  setOptionSelected = () => {},
  defaultChipsClicked,
  setDefaultChipsClicked = () => {},
  sendClickedFunction = () => {},
  chatReady = false,
}) => {
  // const [inputText, setInputText] = useState(input);
  const textareaRef = useRef(null);

  const adjustTextareaHeight = (resetFlag) => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      const lineHeight = parseInt(
        window.getComputedStyle(textarea).lineHeight,
        10
      );
      const maxRows = resetFlag ? 1.8 : 5;
      const newHeight = Math.min(textarea.scrollHeight, maxRows * lineHeight);
      textarea.style.height = `${newHeight}px`;
    }
  };

  const handleChipClick = (chipValue) => {
      if (getUserKb() === 'GHS') {
        setSelectedDocument(chipValue);
        saveSelectedDocument(chipValue);
      }
    // setChipsClicked(true);
    setOptionSelected(false);
  };

  useEffect(() => {
    setInput(input);
  }, [input]);

  const optionClick = (index, input, customQueryFlag = false, image = null, newSession = true) => {
    if (!chatReady) return;
    send(index, input, customQueryFlag, image, newSession);
    setOptionSelected(false);
    // setOptionClicked(true);
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (optionSelected) {
  //       setOptionSelected(false);
  //     }
  //   }, 3000);
  //   return () => clearTimeout(timer);
  // }, [optionSelected]);
  const DefaultChipsLists = {
    DEMOASHADefaultChipsList,
    CTDCHODefaultChipsList,
    WCDAWWDefaultChipsList,
    GAVIASHADefaultChipsList,
    BSHSFPCDefaultChipsList,
    POCANMDefaultChipsList
  }
  const listKey = `${getUserKb()}${getUserCadre()}DefaultChipsList`;
  const chipsList = DefaultChipsLists[listKey] || [];
  useEffect(() => {
    if (!defaultChipsClicked || !chatReady) return;
    handleChipClick(chipsList[0].value[selectedLanguage]);
    optionClick(0, chipsList[0].value[selectedLanguage], false, chipsList[0].img);
    setDefaultChipsClicked(false);
    setChipsClicked(true);
  }, [defaultChipsClicked, chatReady, selectedLanguage, chipsList, handleChipClick, optionClick, setDefaultChipsClicked, setChipsClicked]);
  return (
    <div className="bottomBarDiv py-4">
      <div className="flex items-center gap-2 px-3">
      <div className="w-[88%]">
        <ChatInputBar
          selectedLanguage={selectedLanguage}
          textareaRef={textareaRef}
          optionSelected={optionSelected}
          setOptionSelected={setOptionSelected}
          input={input}
          send={send}
          setInput={setInput}
          adjustTextareaHeight={adjustTextareaHeight}
          textSize={textSize}
          isLoading={isLoading}
          selectedDocument={selectedDocument}
          optionClicked={optionClicked}
          setOptionClicked={setOptionClicked}
          chatReady={chatReady}
        />
      </div>
      <div className="w-[12%]">
        <ChatInputButton
          selectedLanguageCode={selectedLanguage}
          input={input}
          setInput={setInput}
          setAudioArr={setAudioArr}
          audioArr={audioArr}
          send={send}
          adjustTextareaHeight={adjustTextareaHeight}
          isLoading={isLoading}
          audioRef={audioRef}
          stopPlayingAudio={stopPlayingAudio}
          setSpeakerEnabled={setSpeakerEnabled}
          setToastErrorMessage={setToastErrorMessage}
          setShowToastMessage={setShowToastMessage}
          setToastMessageSeverity={setToastMessageSeverity}
          sendClickedFunction={sendClickedFunction}
          chatReady={chatReady}
        />
      </div>
    </div>
      <div className="px-2" id="tour-chips-button" >
        {optionSelected && (
          <div className="mt-3 mb-2 grid gap-2 grid-rows-2 grid-cols-2">
            {chipsList.map((option, index) => {
              return (
                <DefaultChips
                  key={option.id}
                  option={option}
                  selectedLanguage={selectedLanguage}
                  send={optionClick}
                  textSize={textSize}
                  isLoading={isLoading}
                  onChipClick={handleChipClick}
                  setChipsClicked={setChipsClicked}
                  index={index}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomBar;
